document.addEventListener('rebuy.beforeReady', () => {
  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('img[data-src]').forEach((imgElement) => {
          imgElement.src = imgElement.dataset.src;
        });
        observer.disconnect();
      }
    });
  };

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  };
  const observer = new IntersectionObserver(callback, options);

  const targets = document.querySelectorAll('.rebuy-product-grid.js-lazy');
  targets.forEach((target) => {
    observer.observe(target);
  });
});

if (window.Shopify && window.Shopify.theme_settings
  && window.Shopify.theme_settings.scheduled_discount) {
  document.addEventListener('rebuy.ready', (event) => {
    const container = event.detail.widget.template;
    const priceContainers = container?.querySelectorAll(
      '.rebuy-product-price .rebuy-money:not(.compare-at) span:last-of-type',
    );
    priceContainers.forEach((priceEl) => {
      const currencySymbol = priceEl.innerText[0];
      const priceValue = priceEl.innerText.replace(currencySymbol, '');
      const discountMultiplier = (100 * window.Shopify.theme_settings.scheduled_discount) / 100;
      const discountedPrice = (priceValue * discountMultiplier).toFixed(2);
      const priceContainer = priceEl.closest('.rebuy-money');
      priceContainer?.classList.toggle('scheduled-compare-at', true);
      const discountedPriceEl = `<span class="rebuy-money sale"><span class="sr-only">Price</span><span>${currencySymbol}${discountedPrice}</span></span>`;
      priceContainer.insertAdjacentHTML('beforebegin', discountedPriceEl);
    });
  });
}

document.addEventListener('rebuy.ready', () => {
  function isAllowedMarket() {
    if (!window.rebuyCartData) {
      return true;
    }
          const allowedMarkets = window.rebuyCartData.announcementMarkets;
      if (!allowedMarkets || allowedMarkets.trim() === '') {
      return true;
    }
    const currentCountry = window.rebuyCartData.currentCountry;
    if (!currentCountry) {
      return true;
    }
      const allowedMarketsList = allowedMarkets.split(',').map((market) => market.trim().toUpperCase());
      const isAllowed = allowedMarketsList.includes(currentCountry.toUpperCase());
      return isAllowed;
  }
  function filterAnnouncementBar() {
    const shouldShow = isAllowedMarket();
    if (!shouldShow) {
      const announcementBar = document.querySelector('.rebuy-cart__flyout-announcement-bar');
      if (announcementBar) {
        announcementBar.classList.add('hidden-for-international');
      }
      const announcementMessages = document.querySelectorAll('.rebuy-cart__flyout-announcement-bar-message');
      announcementMessages.forEach((message) => {
        message.classList.add('hidden-for-international');
      });
    }
  }
  filterAnnouncementBar();
});
